module.exports = __webpack_public_path__ + "img/map-scenic-active.fb56eb24.png";